import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "bin",
  "use": "bin-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"bin\"><path d=\"M28 7a2 2 0 00-2-2h-5V3.53A1.54 1.54 0 0019.47 2h-6.94A1.54 1.54 0 0011 3.53V5H6a2 2 0 00-2 2v4h2v16a3 3 0 003 3h14a3 3 0 003-3V11h2zM13 4h6v1h-6zm11 23a1 1 0 01-1 1H9a1 1 0 01-1-1V11h16zM6 9V7h20v2z\" /><path d=\"M10 13h2v13h-2zM15 13h2v13h-2zM20 13h2v13h-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/bin.svg
// module id = C8Ay
// module chunks = 39 44